import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  catalogConfigurations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  addConfig: PropTypes.func.isRequired,
};

export function UnstyledSettingsDropDown({ classes, catalogConfigurations, addConfig }) {
  return (
    <TextField
      name="config"
      label="Add Configuration Option"
      placeholder="Select configuration"
      variant="outlined"
      select
      value={0}
      className={classes.nameField}
      fullWidth
      onChange={(event) => addConfig(event.target.value)}
    >
      <MenuItem value="0" disabled>
        {catalogConfigurations && catalogConfigurations.length
          ? 'Configuration Option'
          : 'There are no Configurations to add'}
      </MenuItem>
      {catalogConfigurations.map((item) => (
        <MenuItem key={item.name} value={item.name}>
          {item.name}
          {item.restartRequired ? '*' : null}
        </MenuItem>
      ))}
    </TextField>
  );
}

UnstyledSettingsDropDown.propTypes = propTypes;

const styles = (theme) => ({
  listContent: {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
  inputLabel: {
    color: theme.palette.text.primary,
  },
  nameField: {
    '& label': {
      color: theme.customColors.black,
    },
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
});

export default withStyles(styles)(UnstyledSettingsDropDown);
